// /components/ZipcodeMapModal/ZipcodeMapModal.jsx
import React, { useState, useMemo } from "react";
import './ZipCodeMapModal.css';

const ZipcodeMapModal = ({ isOpen, onClose, countyName, zipcodeData, mapMode }) => {
    const [sortField, setSortField] = useState("total"); // default sort by zip
    const [sortDirection, setSortDirection] = useState("asc"); // or "desc"

    const sortedZipcodeData = useMemo(() => {
        const sorted = [...zipcodeData];

        sorted.sort((a, b) => {
            const aValue = sortField === "zip" ? a.zip : a.total;
            const bValue = sortField === "zip" ? b.zip : b.total;

            if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
            if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [zipcodeData, sortField, sortDirection]);


    if (!isOpen) {
        return null;
    }

    // Decide on a column header depending on mapMode
    const columnHeader = mapMode === 'QHP' ? 'QHP Enrollments' : 'Medicaid Enrollments';

    return (
        <div className="zipcode-map-modal-container">
            {/* Stop propagation so clicks inside the modal don't close it */}
            <div className="zipcode-map-modal-content">
                <button className="zm-close-button" onClick={onClose}>
                    &times;
                </button>

                <h2>{countyName} Zip Code Details</h2>
                <table>
                    <thead>
                        <tr>
                            <th
                                onClick={() => {
                                    if (sortField === "zip") {
                                        setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
                                    } else {
                                        setSortField("zip");
                                        setSortDirection("asc");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                ZIP Code {sortField === "zip" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
                            </th>
                            <th
                                onClick={() => {
                                    if (sortField === "total") {
                                        setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
                                    } else {
                                        setSortField("total");
                                        setSortDirection("asc");
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                {columnHeader} {sortField === "total" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedZipcodeData.length === 0 ? (
                            <tr>
                                <td colSpan="2">No Data Found</td>
                            </tr>
                        ) : (
                            sortedZipcodeData.map((item) => (
                                <tr key={item.zip}>
                                    <td>{item.zip}</td>
                                    <td>{item.total}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ZipcodeMapModal;
